import { type FormEvent, useState } from "react";

import { trpc } from "@blis/trpc/react";

import { Button } from "@/components/ui/button";
import { FieldError, Input, TextField } from "@/components/ui/field";
import { Form } from "@/components/ui/form";
import { Text } from "@/components/ui/text";
import { mutationResponse } from "@/utils/trpc";
import { AuthLayout } from "./AuthLayout";

export function CompleteProfile({ next }: { next?: string }) {
  const [error, setError] = useState<string>("");

  const complete = trpc.auth.completeProfile.useMutation(
    mutationResponse({
      errorTitle: "Error completing profile",
      successMessage: "Profile completed successfully",
      onSuccess: () => {
        window.location.href = next || "/";
      },
      onError: (error) => {
        setError(error.message || "Something went wrong. Please try again.");
      },
    }),
  );

  const onSubmit = async (evt: FormEvent<HTMLFormElement>) => {
    evt.preventDefault();

    const formData = new FormData(evt.currentTarget);
    const values = Object.fromEntries(formData) as {
      firstName: string;
      lastName: string;
    };

    setError("");
    complete.mutate(values);
  };

  return (
    <AuthLayout title="Complete Your Profile">
      <Text muted>Enter your name to continue</Text>
      <div className="flex flex-col w-full mt-6">
        {error && (
          <Text size="2" className="mb-2 text-destructive">
            {error}
          </Text>
        )}
        <Form onSubmit={onSubmit}>
          <div className="flex flex-col gap-4">
            <div className="grid grid-cols-2 gap-4">
              <TextField
                name="firstName"
                type="text"
                isRequired
                aria-label="First name"
              >
                <Input placeholder="First name" />
                <FieldError />
              </TextField>

              <TextField
                name="lastName"
                type="text"
                isRequired
                aria-label="Last name"
              >
                <Input placeholder="Last name" />
                <FieldError />
              </TextField>
            </div>

            <Button
              type="submit"
              isPending={complete.isPending}
              isDisabled={complete.isPending}
            >
              Continue
            </Button>
          </div>
        </Form>
      </div>
    </AuthLayout>
  );
}
